/**
 * @author Harshitha.k
 * @description 
 */

import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
// import { columns } from './mock';
import { Input, Button } from 'antd';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import localStorage from '../../../../utils/localStorage';
import { API_ORGANISATION } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';

const Organisation = ({ translationCache, navigate }) => {
  const [datasource, setDatasource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInputRef = useRef(null);
  
  useEffect(() => {
    const _getOrganisationList = () => {
      const accessToken = localStorage.get('accessToken');
      const orgHeaders = {
        method: 'GET',
        url: `${API_ORGANISATION.GET}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
      axios(orgHeaders)
        .then(({ data }) => {
          setDatasource(data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    _getOrganisationList();
  
  }, []);


  // const _getOrganisationList = () => {
  //   const accessToken = localStorage.get('accessToken');
  //   const orgHeaders = {
  //     method: 'GET',
  //     url: `${API_ORGANISATION.GET}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   axios(orgHeaders)
  //     .then(({ data }) => {
  //       setDatasource(data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const columns = [
    {
      title: translation('Id'),
      dataIndex: 'Id',
      ...getColumnSearchProps('Id')
    },
    {
      title: translation('Organisation Name'),
      dataIndex: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('Short Name'),
      dataIndex: 'ShortName',
      ...getColumnSearchProps('ShortName')
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation('Tag Line'),
      dataIndex: 'TagLine',
      ...getColumnSearchProps('TagLine')
    },
    {
      title: translation('URL'),
      dataIndex: 'URL',
      ...getColumnSearchProps('URL')
    }
  ];

  return (
    <StyledTable size="small"
      columns={columns}
      dataSource={datasource}
      onRow={() => ({
        onClick: () => {
 navigate({
            pathname: `/rubus/settingsPage/UserManagement/Site`
          });
        }
      })}
      pagination={false}
      bordered
    />
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Organisation);
